export default "__VITE_ASSET__C1zE_uRi__"